export const loadSurfsideSegments = (options: { isBuyer?: boolean; isSeller?: boolean }) => {
  if (!window.surf) {
    return;
  }

  window.surf('segment', {
    segmentId: 'isRetailer',
    segmentVal: options.isBuyer ? '1' : '0',
  });

  window.surf('segment', {
    segmentId: 'isSeller',
    segmentVal: options.isSeller ? '1' : '0',
  });
};
